export type AlertId = number;
export enum AlertModel {
  AreaAlert = 'AreaAlert',
  TrailAlert = 'TrailAlert',
  GeoAlert = 'GeoAlert'
}
export enum AlertType {
  WARNING = 'W',
  INFORMATION = 'I',
  CLOSURE = 'C',
  DANGER = 'D'
}
export enum AlertStatus {
  ACTIVE = 'A',
  SCHEDULED = 'S',
  EXPIRED = 'X',
  DELETED = 'D'
}

export type Alert = {
  id?: AlertId;
  type?: AlertModel;
  objectId?: number;
  alertType: AlertType;
  applyToNewTrails?: boolean;
  creatorId?: number;
  status?: string;
  title?: string;
  content: string;
  startDate?: string;
  endDate?: string;
  shortName: string;
  recursAnnually: boolean;
  applyToAreaPage: boolean;
  deleted?: boolean;
  source?: number;
  areaIds?: number[];
};

export enum ObjectType {
  Area = 'area',
  Trail = 'trail',
  Geo = 'geo'
}

export type AlgoliaAlert = {
  ID: AlertId;
  object_type: ObjectType;
  object_id: number;
  name: string;
  alert_type: AlertType;
  status: AlertStatus;
  start_date?: number;
  end_date?: number;
  title?: string;
  source?: number;
};
